import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const PageService = {
  getList: async () => {
    const response = await apiService.get("/pages");
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/pages/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(`/pages/slug?slug=${id}`);
    return response.data;
  },
};

export default PageService;
